<template>
    <div class="g-map-widget">
        <GoogleMap :init="initializeGoogleMap" :markers="markers" />
    </div>
</template>

<script>
    import { provide } from 'vue';
    import GoogleMap from 'googlemaps-vue3/GoogleMap.vue'

    export default {
        name: 'GMapWidget',
        components: { GoogleMap },
        data() {
            return {
                center: { lat: 0, lng: 0 },
                chosenRentals: [],
                chosenRental: {},
                initializeGoogleMap: {
                    zoomControl: true,
                    mapTypeControl: false,
                    scaleControl: true,
                    streetViewControl: false,
                    rotateControl: false,
                    fullscreenControl: true,
                    disableDefaultUi: false,
                    center: { lat: this.center[0], lng: this.center[1] },
                    zoom: this.zoom,
                },
                currentMarker: 0,
            };
        },

        /*watch: {
            rentals(rentals) {
                this.calculateCenter(rentals);
            },

            chosenRentals(value) {
                if (value) {
                    // eslint-disable-next-line prefer-destructuring
                    this.chosenRental = value[0];
                }
                this.currentMarker = 0;
            },
        },*/

        methods: {
            calculateCenter(rentals) {
                const center = { lat: 0, lng: 0 };
                let rentalsLen = 0;
                const keys = Object.keys(rentals);
                // eslint-disable-next-line no-restricted-syntax
                for (const key of keys) {
                    const rental = rentals[key];
                    if (!rental.latitude || !rental.longitude) {
                        // eslint-disable-next-line no-continue
                        continue;
                    }
                    center.lat += rental.latitude;
                    center.lng += rental.longitude;
                    // eslint-disable-next-line no-const-assign,no-plusplus
                    rentalsLen++;
                }
                if (rentalsLen) {
                    center.lat /= rentalsLen;
                    center.lng /= rentalsLen;
                }
                this.center = center;
            },

            onClusterClick(e) {
                this.chosenRentals = [];
                e.getMarkers().forEach((item) => {
                    const rental = this.rentals.find((r) => r.short_name_index === item.getTitle());
                    if (typeof rental !== 'undefined') {
                        this.chosenRentals.push(rental);
                    }
                });
            },

            onMarkerClick(e, rental) {
                // console.log(e);
                // this.top = `${e.ya.y}px`;
                // this.left = `${e.ya.x - 210}px`;
                this.chosenRentals = [rental];
                // this.center = e.latLng;
            },
        },

        created() {
            /*if (this.rentals.length) {
                this.calculateCenter(this.rentals);
            }*/
            provide('googleMapApiKey', this.apiKey);
        },

        props: {
            apiKey: {
                type: String,
                required: true,
            },
            center: {
                type: Array,
                default() {
                    return [0, 0];
                },
            },
            zoom: {
                type: Number,
                default: 12,
            },
            markers: {
                type: Array,
                default() {
                    return [];
                },
            },
            rentals: Array,
            height: {
                type: String,
                default: '100vh',
            },
        },
    };
</script>

<style lang="scss">
    @import '../../scss/variables';

    .g-map-widget {
        position: relative;
        .rentals {
            position: absolute;
            width: 420px;
            max-width: 100%;
            left: calc(50% - 210px);
            bottom: 1rem;
            background: #fff;
            @media (max-width: 600px) {
                & {
                    left: 0;
                }
            }
        }
    }
</style>
